import React from "react";
import { DocumentCard } from "../../../../../components";
import profileImage from "../../../../../assets/images/profile-dummy.png";

const DocumentCardList = () => {
  return (
    <div className="flex flex-1 m-3">
      <DocumentCard height="h-100" width="w-80" image={profileImage} />
    </div>
  );
};

export default DocumentCardList;
